const SIGNIN_TEXT = 'Sign in';
const SIGNOUT_TEXT = 'Sign out';

export default { SIGNIN_TEXT, SIGNOUT_TEXT };
